
import { defineComponent, computed } from "vue";

const __default__ = defineComponent({
  name: "CircleProgress",
  props: {
    done: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    fillColor: {
      type: String,
      default: "var(--primary-color)"
    },
    bgColor: {
      type: String,
      default: "#d3d3d3"
    },
    size: {
      type: String,
      default: "33px"
    }
  },
  setup(props) {
    const percentage = computed(() =>
      props.total > 0 ? Math.min(100, (props.done / props.total) * 100) : 0
    );

    const filledDegrees = computed(() => `${percentage.value * 3.6}deg`);

    const innerSize = computed(() => {
      const numeric = parseFloat(props.size);
      return `${numeric * 0.65}px`;
    });

    return {
      size: props.size,
      fillColor: props.fillColor,
      bgColor: props.bgColor,
      filledDegrees,
      innerSize
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "aad00fb8": (_ctx.size),
  "6ed6c95d": (_ctx.fillColor),
  "0e6342a2": (_ctx.filledDegrees),
  "bdbe31ca": (_ctx.bgColor),
  "d923e598": (_ctx.innerSize)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__